export default {
  namespaced: true,
  state: {
    sideNavStatus: false,
  },
  getters: {
    getSideNavStatus: (state) => {
      return state.sideNavStatus;
    },
  },
  mutations: {
    UPDATE_SIDE_NAV_STATUS(state, sideNavStatus) {
      state.sideNavStatus = sideNavStatus;
    },
  },
  actions: {
    changeSideNavStatus({ commit }, sideNavStatus) {
      commit("UPDATE_SIDE_NAV_STATUS", sideNavStatus);
    },
  },
};
